module.exports = __webpack_public_path__ + "7d712e8cb098942120a6d8c696f6cf47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/slow.png
// module id = 3044
// module chunks = 0